import AlertMessage from "src/components/ui-components/AlertMessage";
import axios from "src/lib/axios";

const API_URLS = {
  GET_CURRENCY_MASTER: `/CurrencyMaster/GetCurrencyMaster`,
  INSERT_UPDATE_CURRENCY: '/Currencies/InsertUpdateCurrency'
};

export const getCurrencyMaster = async (): Promise<any> => {
  try {
    const response = await axios.get(API_URLS.GET_CURRENCY_MASTER);
    return response?.data || [];
  } catch {
    return [];
  }
};

export const insertUpdateCurrency = async (currencyData): Promise<any> => {
  try
  {
    const res = await axios.post(API_URLS.INSERT_UPDATE_CURRENCY, currencyData);
    AlertMessage({ type: 'success', msg: res?.data?.message || `Currency ${currencyData.CurrencyKey ? 'updated' : 'added'} successfully`});
    return res?.data?.isSuccess;
  } catch(err) {
    if (err.errors) {
      Object.entries(err.errors).forEach(([, errMsg]: any) => {
        AlertMessage({ type: 'error', msg: errMsg.errorMessage });
      });
    } else if (err.title) {
      AlertMessage({ type: 'error', msg: err.title });
    } else {
      AlertMessage({ type: 'error', msg: 'Some error occured' });
    }
    return false;
  }
};
